import axios from 'axios'
import Router from '~/router'
import AuthService from 'services/AuthService'
import ValidationService from 'services/ValidationService'

function createResponse({ data, headers, status }) {
    let contentType = headers['content-type'] || ''
    const response =
        (contentType.indexOf('application/json') !== -1 || contentType.indexOf('application/pdf') !== -1) &&
        typeof data === 'object'
            ? data
            : {}

    response._headers = headers
    response._status = status

    return response
}

function createErrorObject(error) {
    function ErrorObject() {
        this.code = error.code
        this.field = error.field
        this.message = error.message
    }

    ErrorObject.prototype.toString = function () {
        return this.message
    }

    return new ErrorObject()
}

function extractErrors({ response: { data: errors } }) {
    return errors.reduce((messages, error) => {
        messages[error.field] = createErrorObject(error)
        return messages
    }, {})
}

axios.defaults.baseURL = env('VUE_APP_API_URL')

axios.interceptors.request.use((config) => {
    if (AuthService.isLoggedIn()) {
        config.headers['Authorization'] = `Bearer ${AuthService.getToken()}`
    }

    return config
})

axios.interceptors.response.use(
    (response) => createResponse(response),
    (error) => {
        error.response = createResponse(error.response)

        if (error.response._status === 401) {
            AuthService.logOut()
            return Router.push({ name: 'index' })
        }

        if (error.response._status === 400 && error.response.code === 'validation_failed') {
            ValidationService.set(extractErrors(error))
        }

        return Promise.reject(error)
    },
)

export default axios
